interface BotFaceIconProps {
  size?: number;
}

// Custom friendly-robot mascot, styled in the site's own warm gold/cream
// palette (not a generic chat-bubble icon, and no black anywhere in it).
export function BotFaceIcon({ size = 32 }: BotFaceIconProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 100 100"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
    >
      {/* antenna */}
      <line x1="50" y1="10" x2="50" y2="22" stroke="#a8896a" strokeWidth="5" strokeLinecap="round" />
      <circle cx="50" cy="8" r="7" fill="#a8896a" />

      {/* ears */}
      <circle cx="12" cy="58" r="10" fill="#a8896a" />
      <circle cx="88" cy="58" r="10" fill="#a8896a" />

      {/* head shell */}
      <rect x="16" y="20" width="68" height="64" rx="24" fill="#fffdf8" />

      {/* screen */}
      <rect x="27" y="34" width="46" height="36" rx="12" fill="#a8896a" />

      {/* eyes */}
      <path d="M37 53 Q42 44 47 53" stroke="#ffffff" strokeWidth="4.2" strokeLinecap="round" />
      <path d="M53 53 Q58 44 63 53" stroke="#ffffff" strokeWidth="4.2" strokeLinecap="round" />

      {/* smile */}
      <path d="M39 61 Q50 69 61 61" stroke="#ffffff" strokeWidth="4.2" strokeLinecap="round" />
    </svg>
  );
}
